import { render, staticRenderFns } from "./AufgabenComponentIndexSearch.vue?vue&type=template&id=a0318a96&scoped=true"
import script from "./AufgabenComponentIndexSearch.vue?vue&type=script&lang=js"
export * from "./AufgabenComponentIndexSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0318a96",
  null
  
)

export default component.exports